/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualOrderStatus
 */
export interface ManualOrderStatus {
    /**
     * 订单状态码
     * @type {number}
     * @memberof ManualOrderStatus
     */
    orderStatusCode?: number;
    /**
     * 订单状态名称（中文）
     * @type {string}
     * @memberof ManualOrderStatus
     */
    orderStatusNameCn?: string;
    /**
     * 订单状态名称（韩文）
     * @type {string}
     * @memberof ManualOrderStatus
     */
    orderStatusNameKr?: string;
}

/**
 * Check if a given object implements the ManualOrderStatus interface.
 */
export function instanceOfManualOrderStatus(value: object): value is ManualOrderStatus {
    return true;
}

export function ManualOrderStatusFromJSON(json: any): ManualOrderStatus {
    return ManualOrderStatusFromJSONTyped(json, false);
}

export function ManualOrderStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualOrderStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'orderStatusCode': json['orderStatusCode'] == null ? undefined : json['orderStatusCode'],
        'orderStatusNameCn': json['orderStatusNameCn'] == null ? undefined : json['orderStatusNameCn'],
        'orderStatusNameKr': json['orderStatusNameKr'] == null ? undefined : json['orderStatusNameKr'],
    };
}

export function ManualOrderStatusToJSON(json: any): ManualOrderStatus {
    return ManualOrderStatusToJSONTyped(json, false);
}

export function ManualOrderStatusToJSONTyped(value?: ManualOrderStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderStatusCode': value['orderStatusCode'],
        'orderStatusNameCn': value['orderStatusNameCn'],
        'orderStatusNameKr': value['orderStatusNameKr'],
    };
}

